import React, {Component} from 'react';
import Head from '../../../Structure/components/Head/Head';
import {Link} from 'react-router';
import {PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN} from "../../../../App/RouterAdopta";

export default class RegistroGraciasPage extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="Homepage-banner">
                <Head
                    previousPath={"registro"}
                />

                <div className="page-login main-content">
                    <div className="container">
                        <div className="container-thanks">
                            <div className="container-text">
                                <h2 className="page-thanks-title">Gracias por registrarte!</h2>
                                <h4 className="page-thanks-subtitle">Ya casi has terminado :)</h4>
                                <h6 className="page-thanks-text">Te hemos enviado un email, revisa tu bandeja de correo
                                    electrónico para verificar tu
                                    dirección</h6>
                            </div>

                            <div className="back-button">
                                <Link to={PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN}
                                      className="btn btn-outline-secondary btn-get-started">Ir
                                    al
                                    login</Link>
                            </div>
                        </div>
                        {/*<img className="image-thanks"*/}
                        {/*    src={process.env.CDN_URL + '/images/adoptaunanimal/thanks/thanks_2.jpg'}*/}
                        {/*     // src={getImageEncode("not_found_animals")}*/}
                        {/*     alt="image-thanks" width="1080" height="785"/>*/}
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        $('.index-resume__heading').show();
        //$('.header-topbar').css("visibility", "visible");
    }
}